import { Component, OnInit,ChangeDetectorRef } from "@angular/core";
import { Observable, take } from "rxjs";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import {
  DataService,
  CustomDetailComponent,
  SharedModule,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
@Component({
  templateUrl: "./version-card.component.html",
  standalone: true,
  imports: [SharedModule],
})
export class VersionCardComponent implements CustomDetailComponent, OnInit {
  entity$: Observable<any>;
  detailForm: FormGroup;
  changes = false;

  constructor(private cdr : ChangeDetectorRef) {}

  version: "";

  ngOnInit() {
    const host = window.location.protocol + "//" + window.location.host;

    fetch(`${host}/version`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((response: any) => {
        console.log(response);
        this.version = response.version;  
        this.cdr.markForCheck()
      });
  }
}
